import API from '../../sunwiseAPI';
const ENTITY = 'aftersales-location';

export const getLocation = (id) => API.get(`/api/v1/${ENTITY}/${id}/sunpay/`);
